export default __webpack_public_path__ + "assets/images/af67726f3c4871898c8a8fa0d073d3d2.png";